import snackbar from "node-snackbar";
import "node-snackbar/dist/snackbar.css";
import { green } from "@material-ui/core/colors";
import { themeObject } from "@theme";
import locale from "@bonliva-crm/locale";

export type Message = SnackbarOptions | string;

export class SnackbarStore {
  success(message: Message) {
    const _message = typeof message === "string" ? { text: message } : message;

    this._issue({
      ..._message,
      backgroundColor: green[600]
    });
  }

  error(message: Message) {
    const _message = typeof message === "string" ? { text: message } : message;

    this._issue({
      ..._message,
      backgroundColor: themeObject.palette.error.main
    });
  }

  /** Something the user has to know about a request that succeeded. */
  warning(message: Message) {
    const _message = typeof message === "string" ? { text: message } : message;

    this._issue({
      ..._message,
      // The theme's amber, which is what `severity="warning"` paints too.
      backgroundColor: themeObject.palette.alter.main
    });
  }

  info(message: Message) {
    const _message = typeof message === "string" ? { text: message } : message;

    this._issue({ ..._message });
  }

  private _issue(options: SnackbarOptions) {
    snackbar.show({
      pos: "top-right",
      customClass: "snackbar-snack",
      actionText: locale.OK,
      actionTextColor: "white",
      ...options
    });
  }
}
